import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Select } from "antd";
import { useQuery } from "@tanstack/react-query";
import { LuChevronRight, LuInbox, LuTrophy } from "react-icons/lu";
import { Spiner } from "@components/loaders/spiner";
import moment from "moment";
import { FilterOutlined } from "@ant-design/icons";
import { PopupCustom } from "@components/general/popup";
import { SchoolService } from "@services/school.service";
import { StudentAchievement } from "@services/dtos/school.dto";

moment.locale("id");

export const AchievementDataPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_ACHIEVEMENT, nis, limit],
    queryFn: () => SchoolService.studentAchievement({ nis, limit }),
  });

  const openDetailPrestasi = (item: StudentAchievement) => {
    navigate(linkPage.ACHIEVEMENT_DETAIL_PAGE, { state: item });
  };

  useEffect(() => {
    setHeader({ buttonBack: true, filter: false, title: "Prestasi", image: false });
    setAppBar({ title: "Prestasi", show: true, leading: "back" });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        {/* filter bar */}
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
          <div className="tw-text-sm tw-text-white/80">
            Menampilkan{" "}
            <span className="tw-font-semibold tw-text-white">
              {limit} data terakhir
            </span>
          </div>
          <FilterOutlined
            className="tw-p-2 tw-text-xl tw-bg-transparent card-body"
            onClick={() => setPopupFilter(true)}
          />
        </div>

        {/* list */}
        {isPending ? (
          <div className="tw-text-center card-body">
            <Spiner />
          </div>
        ) : data?.data != null && data.data.length > 0 ? (
          <div className="tw-space-y-3">
            {data.data.map((item, idx) => (
              <div
                key={idx}
                className="card-body tw-flex tw-items-center tw-gap-3 tw-cursor-pointer"
                onClick={() => openDetailPrestasi(item)}
              >
                <div
                  className="tw-flex tw-items-center tw-justify-center tw-rounded-2xl tw-w-10 tw-h-10 tw-shrink-0"
                  style={{ background: "#fffbeb" }}
                >
                  <LuTrophy className="tw-text-lg tw-text-[#f59e0b]" />
                </div>
                <div className="tw-flex-1 tw-min-w-0">
                  <div className="tw-text-sm tw-font-semibold tw-text-text-primary tw-truncate">
                    {item.prestasi ?? "-"}
                  </div>
                  <div className="tw-text-xs tw-text-text-secondary tw-mt-0.5">
                    {moment(item.tanggal ?? Date.now()).format("DD MMM YYYY")}
                  </div>
                </div>
                <div className="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
                  <span
                    className="tw-text-xs tw-font-bold tw-px-2 tw-py-0.5 tw-rounded-full"
                    style={{ background: "#fffbeb", color: "#b45309" }}
                  >
                    +{item.poin} poin
                  </span>
                  <LuChevronRight className="tw-text-base tw-text-text-secondary" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="tw-p-8 tw-text-center card-body">
            <LuInbox className="tw-mx-auto tw-mb-2 tw-text-5xl tw-text-text-secondary tw-opacity-40" />
            <div className="tw-text-sm tw-text-text-secondary">Data tidak ditemukan</div>
          </div>
        )}
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <Select
          className="tw-text-base"
          placeholder="Pilih Jumlah Ditampilkan"
          defaultValue={limit}
          style={{ width: "100%" }}
          allowClear
          onChange={(e) => setLimit(e)}
          options={[
            { value: "10", label: "10 data terakhir" },
            { value: "25", label: "25 data terakhir" },
            { value: "50", label: "50 data terakhir" },
            { value: "100", label: "100 data terakhir" },
          ]}
        />
        <Button
          onClick={() => setPopupFilter(false)}
          className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-red-500 tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
        >
          Tutup
        </Button>
      </PopupCustom>
    </>
  );
};
